var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "join-row-wrap"
  }, [_c('div', {
    staticClass: "join-row join-row--form"
  }, [_vm._m(0), _c('div', {
    staticClass: "join-table",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("아이디(이메일)")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('div', {
    staticClass: "form-email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email1,
      expression: "user.email1"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "email1"
    },
    domProps: {
      "value": _vm.user.email1
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "email1", $event.target.value);
      }
    }
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v("@")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email2,
      expression: "user.email2"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "email2"
    },
    domProps: {
      "value": _vm.user.email2
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "email2", $event.target.value);
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email3,
      expression: "user.email3"
    }],
    staticClass: "select",
    attrs: {
      "name": "email3"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.user, "email3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.user.email2 = _vm.user.email3;
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("직접입력")]), _c('option', {
    attrs: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    attrs: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    attrs: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("비밀번호")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.password,
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "password", $event.target.value);
      }, _vm.input]
    }
  }), _c('small', {
    staticClass: "text-grey text-grey--right"
  }, [_vm._v("(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)")])])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("비밀번호 확인")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.passwordConfirm,
      expression: "user.passwordConfirm"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "password2"
    },
    domProps: {
      "value": _vm.user.passwordConfirm
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "passwordConfirm", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "row"
    }
  }, [_vm._m(1), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.name,
      expression: "user.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": _vm.user.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "name", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "role": "row"
    }
  }, [_vm._m(2), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.meta.activeName,
      expression: "user.meta.activeName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "nickname"
    },
    domProps: {
      "value": _vm.user.meta.activeName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user.meta, "activeName", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("국내/해외")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.type,
      expression: "user.type"
    }],
    staticClass: "select",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.user, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ko"
    }
  }, [_vm._v("국내이용자")]), _c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("해외이용자")])])])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("연락처")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_vm.user.type == 'ko' ? _c('div', {
    staticClass: "form-tel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone1,
      expression: "user.phone1"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone1",
      "maxlength": "4",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.phone1
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "phone1", $event.target.value);
      }, _vm.input],
      "click": _vm.certify
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone2,
      expression: "user.phone2"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone2",
      "maxlength": "4",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.phone2
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "phone2", $event.target.value);
      }, _vm.input],
      "click": _vm.certify
    }
  }), _c('span', {
    staticClass: "text"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone3,
      expression: "user.phone3"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "name": "phone3",
      "maxlength": "4",
      "readonly": ""
    },
    domProps: {
      "value": _vm.user.phone3
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "phone3", $event.target.value);
      }, _vm.input],
      "click": _vm.certify
    }
  })]) : _c('div', {
    staticClass: "form-tel-en"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("+")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone0,
      expression: "user.phone0"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "phone0",
      "placeholder": "82"
    },
    domProps: {
      "value": _vm.user.phone0
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "phone0", $event.target.value);
      }, _vm.input]
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.phone,
      expression: "user.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "10-0000-0000"
    },
    domProps: {
      "value": _vm.user.phone
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user, "phone", $event.target.value);
      }, _vm.input]
    }
  })])])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("작품민팅 URL")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.meta.surveyURL,
      expression: "user.meta.surveyURL"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "surveyURL"
    },
    domProps: {
      "value": _vm.user.meta.surveyURL
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user.meta, "surveyURL", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("홈페이지 URL")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.meta.siteURL,
      expression: "user.meta.siteURL"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "siteURL"
    },
    domProps: {
      "value": _vm.user.meta.siteURL
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user.meta, "siteURL", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("인스타그램 URL")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.meta.instagramURL,
      expression: "user.meta.instagramURL"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "instagramURL"
    },
    domProps: {
      "value": _vm.user.meta.instagramURL
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user.meta, "instagramURL", $event.target.value);
      }, _vm.input]
    }
  })])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v("트위터 URL")]), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.meta.twitterURL,
      expression: "user.meta.twitterURL"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "twitterURL"
    },
    domProps: {
      "value": _vm.user.meta.twitterURL
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.user.meta, "twitterURL", $event.target.value);
      }, _vm.input]
    }
  })])])])])])]), _c('div', {
    staticClass: "bottom-button"
  }, [_c('button', {
    staticClass: "button button--border-primary",
    on: {
      "click": function ($event) {
        return _vm.cancel();
      }
    }
  }, [_c('span', [_vm._v("취소하기")])]), _c('button', {
    staticClass: "button button--primary",
    on: {
      "click": function ($event) {
        return _vm.submit();
      }
    }
  }, [_c('span', [_vm._v("회원가입")])])]), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "change": function (_ref) {
        var postcode = _ref.postcode,
          address = _ref.address;
        _vm.user.postcode = postcode;
        _vm.user.address1 = address;
      }
    }
  }), _c('kcp-cert', {
    ref: "kcp-cert",
    on: {
      "input": _vm.verify
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "join-caption join-caption--center"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("회원정보 필수입력")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("이름")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_c('span', [_vm._v("작가활동명")])]);

}]

export { render, staticRenderFns }